import { useState } from 'react';
import { knowledge as seedKnowledge, memoryEvents, memoryProposals, workflows as seedWorkflows } from '../data/beheer/memory';
import { db } from '../utils/db';
import type { KnowledgeItem, MemoryEvent, MemoryProposal, WorkflowItem } from '../types/settings';

/** Local memory editing: accept/reject proposals, forget items. Every change is logged. */
export function useMemoryStore() {
  const [proposals, setProposals] = useState<MemoryProposal[]>(memoryProposals);
  const [knowledge, setKnowledge] = useState<KnowledgeItem[]>(seedKnowledge);
  const [workflows, setWorkflows] = useState<WorkflowItem[]>(seedWorkflows);
  const [events, setEvents] = useState<MemoryEvent[]>(memoryEvents);

  const log = (summary: string, outcome: 'goedgekeurd' | 'afgewezen' | 'uitgevoerd') =>
    db.log({ agent: 'systeem', summary, level: 'naOk', where: 'lokaal', outcome });

  const accept = (id: string) => {
    const p = proposals.find((x) => x.id === id);
    if (!p) return;
    setProposals((list) => list.filter((x) => x.id !== id));
    if (p.kind === 'kennis') {
      setKnowledge((k) => [{ id: `k-${id}`, topic: 'Voorkeuren', text: p.text, source: 'Voorstel, door jou bevestigd', learned: 'vandaag', uses: 0 }, ...k]);
    } else {
      setWorkflows((w) => [{ id: `w-${id}`, area: 'Gewoonte', rule: p.text, learned: 'vandaag, door jou bevestigd' }, ...w]);
    }
    log(`Geheugen: "${p.text.slice(0, 48)}…" onthouden`, 'goedgekeurd');
  };

  const reject = (id: string) => {
    const p = proposals.find((x) => x.id === id);
    setProposals((list) => list.filter((x) => x.id !== id));
    if (p) log(`Geheugen: voorstel niet onthouden`, 'afgewezen');
  };

  const forgetKnowledge = (id: string) => {
    setKnowledge((k) => k.filter((x) => x.id !== id));
    log('Geheugen: kennis vergeten', 'uitgevoerd');
  };
  const forgetWorkflow = (id: string) => {
    setWorkflows((w) => w.filter((x) => x.id !== id));
    log('Geheugen: werkwijze vergeten', 'uitgevoerd');
  };
  const forgetEvent = (id: string) => {
    setEvents((e) => e.filter((x) => x.id !== id));
    log('Geheugen: gebeurtenis vergeten', 'uitgevoerd');
  };

  return { proposals, knowledge, workflows, events, accept, reject, forgetKnowledge, forgetWorkflow, forgetEvent };
}
